module.exports = __webpack_public_path__ + "static/img/bg_business_h9.6ce53d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/bg_business_h9.png
// module id = GTQW
// module chunks = 3